"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    step: {
      type: Number,
      default: 1
    },
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    stepArr: function stepArr() {
      return [{
        step: 1,
        txt: this.$t('storeVisitReport.step.RSInfo')
      }, {
        step: 2,
        txt: this.$t('storeVisitReport.step.sales')
      }, {
        step: 3,
        txt: this.$t('storeVisitReport.step.TPPRecords')
      }, {
        step: 4,
        txt: this.$t('storeVisitReport.step.salesRecord')
      }, {
        step: 5,
        txt: this.$t('storeVisitReport.step.trainingRecord')
      }, {
        step: 6,
        txt: this.$t('storeVisitReport.step.visitorRecord')
      }];
    }
  },
  methods: {
    // 跳转
    jumpStep: function jumpStep(targetStep) {
      if (this.mode === 'error') {
        return false;
      } else if (this.mode !== 'edit') {
        this.$emit('jump', targetStep);
      } else if (targetStep < this.step) {
        this.$emit('jump', targetStep);
      }
    }
  }
};